import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";

export const workflowReducer = (
  state: LoanState,
  action: PayloadAction<string>,
) => {
  state.workflowId = action.payload;
};
